// extracted by mini-css-extract-plugin
export default {"title":"MasterSaleDetails_title__zN8OU","total":"MasterSaleDetails_total__bt6Lm","edit":"MasterSaleDetails_edit__zDmkm","cancel":"MasterSaleDetails_cancel__W9t3o"};